import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { GetBrokerList, UpdateBrokerStatus } from '../../../Services/Admin/Admin';
import Table from '../../../Extracomponents/Table1';
import { fDateTime } from '../../../../Utils/Date_formate';
import showCustomAlert from '../../../Extracomponents/CustomAlert/CustomAlert';

const BrokerList = () => {
    const [brokers, setBrokers] = useState([]);
    const [searchInput, setSearchInput] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [totalRows, setTotalRows] = useState(0);

    const token = localStorage.getItem('token');

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const getlist = async () => {
        try {
            const response = await GetBrokerList(token);
            if (response.status) {
                // If it's a paginated response, we can use response.pagination
                // But typically basic settings lists might just be a full array
                let data = response.data || [];
                if (searchInput) {
                    data = data.filter(item => 
                        (item.title && item.title.toLowerCase().includes(searchInput.toLowerCase())) ||
                        (item.name && item.name.toLowerCase().includes(searchInput.toLowerCase()))
                    );
                }
                setTotalRows(data.length);
                setBrokers(data);
            }
        } catch (error) {
            console.log("Error fetching broker list:", error);
        }
    };

    useEffect(() => {
        getlist();
    }, [searchInput, currentPage]);

    const handleSwitchChange = async (event, id) => {
        const checked = event.target.checked;
        try {
            const data = { id: id, status: checked ? 1 : 0 };
            const response = await UpdateBrokerStatus(data, token);
            if (response.status) {
                showCustomAlert("Success", "Broker status updated successfully");
                getlist();
            } else {
                showCustomAlert("error", response.message || "Failed to update status");
                getlist(); // Revert switch if failed
            }
        } catch (error) {
            showCustomAlert("error", "Network error updating status");
            getlist();
        }
    };

    const columns = [
        {
            name: 'S.No',
            selector: (row, index) => index + 1,
            sortable: false,
            width: '100px',
        },
        {
            name: 'Broker Name',
            selector: row => row.title || row.name || "Unknown",
            sortable: true,
        },
        {
            name: 'Status',
            selector: row => (
                <div className="form-check form-switch form-check-info">
                    <input
                        id={`broker_${row._id || row.id}`}
                        className="form-check-input toggleswitch"
                        type="checkbox"
                        checked={row.status == 1 || row.status == true}
                        onChange={(event) => handleSwitchChange(event, row._id || row.id)}
                    />
                    <label
                        htmlFor={`broker_${row._id || row.id}`}
                        className="checktoggle checkbox-bg"
                    ></label>
                </div>
            ),
            sortable: true,
        },
    ];

    return (
        <div>
            <div className="page-content">
                <div className="page-breadcrumb d-flex align-items-center mb-3">
                    <div className="breadcrumb-title pe-3">Broker List</div>
                    <div className="ps-3">
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb mb-0 p-0">
                                <li className="breadcrumb-item">
                                    <Link to="/admin/dashboard">
                                        <i className="bx bx-home-alt" />
                                    </Link>
                                </li>
                            </ol>
                        </nav>
                    </div>
                </div>

                <div className="card">
                    <div className="card-body">
                        <div className="d-sm-flex align-items-center mb-4 gap-3 justify-content-between">
                            <div className="position-relative">
                                <input
                                    type="text"
                                    className="form-control ps-5 radius-10"
                                    placeholder="Search Broker..."
                                    onChange={(e) => setSearchInput(e.target.value)}
                                    value={searchInput}
                                />
                                <span className="position-absolute top-50 product-show translate-middle-y">
                                    <i className="bx bx-search" />
                                </span>
                            </div>
                        </div>
                        <div className="table-responsive">
                            <Table
                                columns={columns}
                                data={brokers}
                                totalRows={totalRows}
                                currentPage={currentPage}
                                onPageChange={handlePageChange}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BrokerList;
